import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ContentService, FooterLink, FooterLinkIcon } from '../../../cms/content.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  footerLinks: FooterLink[] = [];

  private readonly iconClasses: Record<FooterLinkIcon, string> = {
    facebook: 'fab fa-facebook-f',
    twitter: 'fab fa-twitter',
    linkedin: 'fab fa-linkedin-in',
    instagram: 'fab fa-instagram',
    skype: 'fab fa-skype',
    website: 'fas fa-link'
  };

  constructor(
    private viewportScroller: ViewportScroller,
    private content: ContentService
  ) {}

  public onClick(elementId: string): void { 
      this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
    this.content.getFooterLinks().subscribe({
      next: response => this.footerLinks = response.data,
      error: () => this.footerLinks = []
    });
  }

  iconClass(icon: FooterLinkIcon): string {
    return this.iconClasses[icon] || this.iconClasses.website;
  }

}
